export default "__VITE_ASSET__SZDaVn6b__"